import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const CustomizedTextField = withStyles({
  root: {
    display: 'flex',
    margin: '10px 0px 10px 0px',
    height: '40px',

    '& fieldset': {
      borderRadius: 0,
      height: '40px',
    },
    '& .MuiOutlinedInput-input': {
      padding: '9px 14px',
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
    '& .MuiFormLabel-root': {
      fontFamily: 'Suisse-Intl',
    },
    '& .MuiInputBase-root': {
      fontFamily: 'Suisse-Intl',
    },
  },
})(TextField);

const CustomizedTextArea = withStyles({
  root: {
    display: 'flex',
    margin: '10px 0px 10px 0px',
    '& fieldset': {
      borderRadius: 0,
    },
    '& .MuiOutlinedInput-input': {
      padding: '9px 14px',
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 10px) scale(1)',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
    '& .MuiFormLabel-root': {
      fontFamily: 'Suisse-Intl',
    },
    '& .MuiInputBase-root': {
      fontFamily: 'Suisse-Intl',
    },
  },
})(TextField);

const CustomTextFieldComponent = ({ ...props }) => {
  return props.multiline ? (
    <CustomizedTextArea {...props} variant="outlined" />
  ) : (
    <CustomizedTextField {...props} variant="outlined" />
  );
};

export default CustomTextFieldComponent;
